import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/display.css";

import "zr-base-layout/src/styles/scss/element-variables.scss";

Vue.use(ElementUI, {
  size: "small",
});
